import type { Bi } from '../types'

export const translations = {
  // Global / nav
  'nav.services': { en: 'Services', es: 'Servicios' },
  'nav.projects': { en: 'Projects', es: 'Proyectos' },
  'nav.about': { en: 'About Us', es: 'Nosotros' },
  'nav.areas': { en: 'Service Areas', es: 'Áreas de Servicio' },
  'nav.contact': { en: 'Contact', es: 'Contacto' },
  'nav.home': { en: 'Home', es: 'Inicio' },
  'nav.blog': { en: 'Blog', es: 'Blog' },
  'nav.menu': { en: 'Open main menu', es: 'Abrir menú principal' },
  'nav.closeMenu': { en: 'Close menu', es: 'Cerrar menú' },
  'nav.language': { en: 'Language', es: 'Idioma' },
  'nav.langEn': { en: 'Switch to English', es: 'Cambiar a inglés' },
  'nav.langEs': { en: 'Switch to Spanish', es: 'Cambiar a español' },
  'nav.servicesMenu': { en: 'Browse all services', es: 'Ver todos los servicios' },
  'nav.phoneAria': { en: 'Phone: +1 360-463-7104', es: 'Teléfono: +1 360-463-7104' },

  'cta.inspection': { en: 'Free Inspection', es: 'Inspección Gratis' },
  'cta.scheduleInspection': { en: 'Schedule Free Inspection', es: 'Agenda tu Inspección Gratis' },
  'cta.scheduleToday': { en: 'Schedule Your Free Inspection Today', es: 'Agenda tu Inspección Gratis Hoy' },
  'cta.viewWork': { en: 'View Our Work', es: 'Ver Nuestro Trabajo' },
  'cta.learnMore': { en: 'Learn More', es: 'Más Información' },
  'cta.call': { en: 'Call', es: 'Llamar' },
  'cta.whatsapp': { en: 'Chat on WhatsApp', es: 'Chatear por WhatsApp' },
  'cta.backToTop': { en: 'Back to top', es: 'Volver arriba' },
  'cta.readMore': { en: 'Read More', es: 'Leer Más' },
  'cta.viewProject': { en: 'View Project Details', es: 'Ver Detalles del Proyecto' },
  'cta.requestEstimate': { en: 'Request Free Estimate', es: 'Solicitar Presupuesto Gratis' },

  // Hero
  'hero.h1': {
    en: 'Professional Foundation & Crawl Space Solutions for Washington Homes',
    es: 'Soluciones Profesionales de Cimientos y Crawl Space para Casas de Washington',
  },
  'hero.sub': {
    en: 'Expert foundation repair, crawl space encapsulation, and insulation installation. Free inspections and expert guidance available today.',
    es: 'Reparación experta de cimientos, encapsulado de crawl space e instalación de aislamiento. Inspecciones gratis y asesoría experta disponibles hoy.',
  },
  'hero.badge1': { en: '30+ Years Combined Experience', es: '30+ Años de Experiencia Combinada' },
  'hero.badge2': { en: 'Licensed & Insured Professionals', es: 'Profesionales con Licencia y Seguro' },
  'hero.badge3': { en: 'Free Home Inspections', es: 'Inspecciones Gratuitas' },
  'hero.badge4': { en: 'Serving Washington State', es: 'Servicio en Todo Washington' },
  'hero.imageAlt': {
    en: 'Clean, professionally finished crawl space with new vapor barrier and support posts in a Washington home',
    es: 'Crawl space limpio y terminado profesionalmente con barrera de vapor y postes nuevos en una casa de Washington',
  },
  'hero.callNow': { en: 'Call now', es: 'Llama ahora' },

  // Services
  'services.title': {
    en: 'Complete Foundation & Home Structural Solutions',
    es: 'Soluciones Completas de Cimientos y Estructura del Hogar',
  },
  'services.sub': {
    en: 'From foundation repairs to crawl space restoration, we handle all your structural needs',
    es: 'Desde reparación de cimientos hasta restauración de crawl spaces, cubrimos todas tus necesidades estructurales',
  },
  'services.whatIncluded': { en: "What's included", es: 'Qué incluye' },
  'services.related': { en: 'Related Services', es: 'Servicios Relacionados' },
  'services.allServices': { en: 'All Services', es: 'Todos los Servicios' },

  // Trust bar
  'trust.title': { en: 'Trusted across Washington State', es: 'Confianza en todo el estado de Washington' },

  // Why choose
  'why.title': {
    en: 'Why Choose IG Contracting & Foundation Systems?',
    es: '¿Por Qué Elegir IG Contracting & Foundation Systems?',
  },
  'why.intro': {
    en: "When your home's structural integrity is at stake, you need professionals you can trust.",
    es: 'Cuando la integridad estructural de tu hogar está en juego, necesitas profesionales de confianza.',
  },
  'why.p1.title': { en: 'Expert Diagnosis', es: 'Diagnóstico Experto' },
  'why.p1.desc': {
    en: 'Thorough assessment of structural issues and damage, documented with photos you keep.',
    es: 'Evaluación minuciosa de problemas estructurales y daños, documentada con fotos que te quedas.',
  },
  'why.p2.title': { en: 'Quality Materials', es: 'Materiales de Calidad' },
  'why.p2.desc': {
    en: 'Premium materials and proven repair techniques built for the Pacific Northwest climate.',
    es: 'Materiales premium y técnicas comprobadas hechas para el clima del noroeste del Pacífico.',
  },
  'why.p3.title': { en: 'Professional Team', es: 'Equipo Profesional' },
  'why.p3.desc': {
    en: 'Experienced technicians, fully licensed and insured, bilingual in English and Spanish.',
    es: 'Técnicos experimentados, con licencia y seguro completos, bilingües en inglés y español.',
  },
  'why.p4.title': { en: 'Competitive Pricing', es: 'Precios Competitivos' },
  'why.p4.desc': {
    en: 'Affordable solutions without compromising quality, with written estimates and no hidden fees.',
    es: 'Soluciones accesibles sin sacrificar calidad, con presupuestos por escrito y sin cargos ocultos.',
  },
  'why.p5.title': { en: 'Complete Warranty', es: 'Garantía Completa' },
  'why.p5.desc': {
    en: 'Workmanship warranty on every repair and installation, with long-term support after the job.',
    es: 'Garantía de mano de obra en cada reparación e instalación, con soporte a largo plazo.',
  },

  // Areas
  'areas.title': { en: 'Serving Washington State Communities', es: 'Al Servicio de las Comunidades de Washington' },
  'areas.sub': {
    en: 'Professional foundation and crawl space services across Washington',
    es: 'Servicios profesionales de cimientos y crawl space en todo Washington',
  },
  'areas.homeBase': { en: 'Home Base', es: 'Base Principal' },
  'areas.alsoServing': { en: 'We also serve', es: 'También atendemos' },
  'areas.viewArea': { en: 'View local services', es: 'Ver servicios locales' },
  'areas.allAreas': { en: 'All Service Areas', es: 'Todas las Áreas' },
  'areas.localTitle': { en: 'Local services in', es: 'Servicios locales en' },
  'areas.localProjects': { en: 'Recent work near', es: 'Trabajos recientes cerca de' },

  // Projects
  'projects.title': { en: 'Completed Projects & Transformations', es: 'Proyectos Completados y Transformaciones' },
  'projects.sub': {
    en: "See how we've protected and restored hundreds of Washington homes",
    es: 'Mira cómo hemos protegido y restaurado cientos de casas en Washington',
  },
  'projects.before': { en: 'Before', es: 'Antes' },
  'projects.after': { en: 'After', es: 'Después' },
  'projects.drag': { en: 'Drag to compare before and after', es: 'Arrastra para comparar antes y después' },
  'projects.slider': { en: 'Before and after comparison slider', es: 'Control de comparación antes y después' },
  'projects.close': { en: 'Close project details', es: 'Cerrar detalles del proyecto' },
  'projects.service': { en: 'Service performed', es: 'Servicio realizado' },
  'projects.none': { en: 'No projects in this category yet.', es: 'Aún no hay proyectos en esta categoría.' },

  // About
  'about.title': { en: 'About IG Contracting & Foundation Systems', es: 'Sobre IG Contracting & Foundation Systems' },
  'about.story': {
    en: 'For 30+ years combined, IG Foundation Systems has been protecting Washington homes and businesses through expert foundation repair, crawl space solutions, and professional insulation services. We believe every home deserves a strong foundation and proper structural integrity.',
    es: 'Con más de 30 años de experiencia combinada, IG Foundation Systems protege hogares y negocios de Washington con reparación experta de cimientos, soluciones de crawl space y aislamiento profesional. Creemos que cada hogar merece un cimiento fuerte.',
  },
  'about.b1': { en: 'Family-owned business with deep roots in Washington', es: 'Negocio familiar con raíces profundas en Washington' },
  'about.b2': { en: 'Licensed and insured professionals', es: 'Profesionales con licencia y seguro' },
  'about.b3': { en: 'Commitment to quality and customer satisfaction', es: 'Compromiso con la calidad y la satisfacción del cliente' },
  'about.b4': { en: 'Bilingual team (English & Spanish)', es: 'Equipo bilingüe (inglés y español)' },
  'about.b5': { en: 'Free professional inspections', es: 'Inspecciones profesionales gratuitas' },
  'about.cta': { en: 'Learn More About Our Team', es: 'Conoce Más Sobre Nuestro Equipo' },
  'about.teamAlt': {
    en: 'IG Contracting & Foundation Systems crew standing in front of their work truck in Washington',
    es: 'Equipo de IG Contracting & Foundation Systems frente a su camioneta de trabajo en Washington',
  },
  'about.workAlt': {
    en: 'Technician installing a steel support jack in a clean encapsulated crawl space',
    es: 'Técnico instalando un soporte de acero en un crawl space encapsulado y limpio',
  },

  // Process
  'process.title': { en: 'Our Professional Process', es: 'Nuestro Proceso Profesional' },
  'process.sub': {
    en: "From inspection to completion — here's how we restore your home's structural integrity",
    es: 'De la inspección a la entrega: así restauramos la integridad estructural de tu hogar',
  },
  'process.step': { en: 'Step', es: 'Paso' },

  // Testimonials
  'testimonials.title': { en: 'What Our Customers Say', es: 'Lo Que Dicen Nuestros Clientes' },
  'testimonials.sub': {
    en: "Real feedback from Washington homeowners we've helped",
    es: 'Comentarios reales de propietarios de Washington a quienes ayudamos',
  },
  'testimonials.prev': { en: 'Previous testimonial', es: 'Testimonio anterior' },
  'testimonials.next': { en: 'Next testimonial', es: 'Siguiente testimonio' },
  'testimonials.rating': { en: '5 out of 5 stars', es: '5 de 5 estrellas' },

  // Blog
  'blog.title': { en: 'Foundation & Home Maintenance Tips', es: 'Consejos de Cimientos y Mantenimiento del Hogar' },
  'blog.sub': {
    en: 'Practical guidance from our technicians for Washington homeowners',
    es: 'Guía práctica de nuestros técnicos para propietarios en Washington',
  },

  // CTA band
  'ctaBand.title': { en: "Ready to Protect Your Home's Foundation?", es: '¿Listo para Proteger el Cimiento de tu Hogar?' },
  'ctaBand.sub': {
    en: 'Schedule your free professional inspection today',
    es: 'Agenda hoy tu inspección profesional gratuita',
  },

  // Contact
  'contact.title': { en: 'Schedule Your Free Inspection', es: 'Agenda tu Inspección Gratuita' },
  'contact.sub': {
    en: 'Tell us what you are seeing and we will get a licensed technician out to you — usually within 48 hours.',
    es: 'Cuéntanos qué estás viendo y enviaremos un técnico con licencia, normalmente en 48 horas.',
  },
  'contact.name': { en: 'Full name', es: 'Nombre completo' },
  'contact.phone': { en: 'Phone number', es: 'Teléfono' },
  'contact.email': { en: 'Email address', es: 'Correo electrónico' },
  'contact.service': { en: 'Service you need', es: 'Servicio que necesitas' },
  'contact.location': { en: 'Property location', es: 'Ubicación de la propiedad' },
  'contact.message': { en: 'Describe the issue', es: 'Describe el problema' },
  'contact.messagePlaceholder': {
    en: 'Cracks, damp crawl space, sagging floors, cold rooms…',
    es: 'Grietas, crawl space húmedo, pisos hundidos, cuartos fríos…',
  },
  'contact.langPref': { en: 'Preferred language', es: 'Idioma preferido' },
  'contact.select': { en: 'Select an option', es: 'Selecciona una opción' },
  'contact.required': { en: 'required', es: 'obligatorio' },
  'contact.privacy': {
    en: 'We respect your privacy. Your information is secure and never shared.',
    es: 'Respetamos tu privacidad. Tu información está segura y nunca se comparte.',
  },
  'contact.sending': { en: 'Sending…', es: 'Enviando…' },
  'contact.successTitle': { en: 'Request received', es: 'Solicitud recibida' },
  'contact.successBody': {
    en: 'Thank you. A technician will call you within one business day to confirm your free inspection.',
    es: 'Gracias. Un técnico te llamará en un día hábil para confirmar tu inspección gratuita.',
  },
  'contact.another': { en: 'Send another request', es: 'Enviar otra solicitud' },
  'contact.errName': { en: 'Please enter your name.', es: 'Ingresa tu nombre.' },
  'contact.errPhone': { en: 'Please enter a valid phone number.', es: 'Ingresa un teléfono válido.' },
  'contact.errEmail': { en: 'Please enter a valid email address.', es: 'Ingresa un correo válido.' },
  'contact.errService': { en: 'Please choose a service.', es: 'Elige un servicio.' },
  'contact.infoTitle': { en: 'Contact Information', es: 'Información de Contacto' },
  'contact.hours': { en: 'Business hours', es: 'Horario' },
  'contact.serviceArea': { en: 'Service area', es: 'Área de servicio' },
  'contact.serviceAreaValue': {
    en: 'Shelton, WA and communities across Western Washington',
    es: 'Shelton, WA y comunidades de todo el oeste de Washington',
  },
  'contact.mapTitle': { en: 'Map of our Washington State service area', es: 'Mapa de nuestra área de servicio en Washington' },
  'contact.follow': { en: 'Follow us', es: 'Síguenos' },

  // Footer
  'footer.about': {
    en: 'Foundation repair, crawl space encapsulation, basement waterproofing, and insulation for homes across Washington State. Licensed, insured, and bilingual.',
    es: 'Reparación de cimientos, encapsulado de crawl space, impermeabilización de sótanos y aislamiento para casas en todo Washington. Con licencia, seguro y equipo bilingüe.',
  },
  'footer.services': { en: 'Services', es: 'Servicios' },
  'footer.areas': { en: 'Service Areas', es: 'Áreas de Servicio' },
  'footer.contact': { en: 'Contact & Support', es: 'Contacto y Soporte' },
  'footer.legal': { en: 'Follow & Legal', es: 'Síguenos y Legal' },
  'footer.viewAllServices': { en: 'View All Services', es: 'Ver Todos los Servicios' },
  'footer.viewAllAreas': { en: 'View All Areas', es: 'Ver Todas las Áreas' },
  'footer.privacy': { en: 'Privacy Policy', es: 'Política de Privacidad' },
  'footer.terms': { en: 'Terms of Service', es: 'Términos del Servicio' },
  'footer.sitemap': { en: 'Sitemap', es: 'Mapa del Sitio' },
  'footer.rights': { en: 'All rights reserved.', es: 'Todos los derechos reservados.' },

  // Not found
  'nf.title': { en: 'Page not found', es: 'Página no encontrada' },
  'nf.body': {
    en: 'That page has moved or never existed. Head back home to find the service you need.',
    es: 'Esa página se movió o nunca existió. Vuelve al inicio para encontrar el servicio que necesitas.',
  },
  'nf.cta': { en: 'Back to home', es: 'Volver al inicio' },
} satisfies Record<string, Bi>

export type TranslationKey = keyof typeof translations
